<template>
  <div class="company-list-container">
    <!--<div class="nav-bar flex-align__between">-->
    <!--  <div class="nav-bar__left flex-align">-->
    <!--    <img class="m-r-20" :src="require('@/assets/images/logo.png')" alt="" />-->
    <!--    <div class="platform-title">{{ platformTitle }}</div>-->
    <!--  </div>-->
    <!--</div>-->
    <div
      v-loading="fullScreenLoading"
      element-loading-text="正在登录企业..."
      class="company-select-card"
    >
      <div class="title default">选择企业</div>

      <div class="card-content">
        <div class="title-tip">
          <span>请在下方选择您将进入的企业或创建新的企业</span>
        </div>

        <div v-if="companyList.length === 0" class="no-company-tip">
          <el-divider />
          <span>您当前未添加任何企业，您可点击下方按钮创建新企业</span>
        </div>

        <div class="company-list">
          <div
            v-for="company in companyList"
            :key="company.companyId"
            class="company"
            :class="{
              disabled:
                company.companyStatus === companyStatusDict.FORBIDDEN.value,
              active: companyId === company.companyId
            }"
            @click="enterCompany(company)"
          >
            <div class="company-info">
              <preview-image
                class="company-logo"
                size="1.75rem"
                :file-id="company.logo"
                :error-img="require('@/assets/images/qiyetouxiang.png')"
              />
              <div
                class="company-name text-ellipsis"
                :title="company.companyName"
              >
                {{ company.companyName }}
              </div>
            </div>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>

        <div class="operate">
          <div class="add-company" @click="createNewCompany">
            <span class="add-icon"><i class="el-icon-plus"></i></span>
            <el-button class="add-button" type="text">创建新企业</el-button>
          </div>
        </div>

        <div class="operate">
          <el-button
            :loading="loading"
            type="primary"
            class="back-login-button"
            size="medium"
            @click="backLogin"
          >
            {{ returnUrl ? '返回' : '返回登录' }}
          </el-button>
        </div>
      </div>
    </div>
    <div class="footer">
      <div>
        <div class="friendly-links">
          友情链接：
          <el-link :underline="false" href="http://www.jxzxtz.com">
            江西省咨询投资集团有限公司
          </el-link>
          <el-link :underline="false" href="http://www.jxbidding.com">
            江西省机电设备招标有限公司
          </el-link>
          <el-link :underline="false" href="http://www.gxbidding.com">
            广西机电设备招标有限公司
          </el-link>
        </div>
      </div>
      <div class="copy-right">
        <span>Copyright©2017-2021 精彩纵横 版权所有</span>
        <a href="https://beian.miit.gov.cn/">赣ICP备17007647号-6</a>
        <span>赣B2-20180066</span>
      </div>
    </div>
  </div>
</template>

<script>
import PreviewImage from '@/components/common/Upload/PreviewImage'

import { enterCompanyApi, getJoinCompanyApi } from '@/api/user'

import { companyStatusDict } from '@/dictionary/company'
import { employeeStatusDict } from '@/dictionary/user'
import { mapActions, mapState, mapGetters } from 'vuex'
import { isObject } from 'lodash'

export default {
  name: 'SelectCompany',

  components: {
    PreviewImage
  },

  data() {
    return {
      platformTitle: '精彩纵横云采购平台',

      companyList: [],
      companyStatusDict,
      returnUrl: this.$route.query.returnUrl,
      jumpPath:
        this.$route.query.jumpPath || JSON.stringify({ name: 'Homepage' }), // 记录前往云平台的路由
      loading: false,
      fullScreenLoading: false
    }
  },

  computed: {
    ...mapState('company', ['companyId']),
    ...mapGetters('company', ['loginAddress'])
  },

  created() {
    getJoinCompanyApi().then(res => {
      this.companyList = (res.data || []).filter(
        value => value.employeeStatus === employeeStatusDict.NORMAL.value
      )

      if (this.companyList.length === 1) {
        this.fullScreenLoading = true
        setTimeout(() => {
          this.enterCompany(this.companyList[0])
        }, 0)
      }
      // 记录第三方公司的id，直接跳转该公司，不用再选择公司
      this.enterCompanyFromThirdAccess()
    })
  },

  methods: {
    ...mapActions('user', ['logout']),
    backLogin() {
      if (this.returnUrl) {
        window.location.href = this.returnUrl
        return
      }
      this.loading = true
      this.logout()
        .then(res => {
          if (res.success) {
            window.location.href = this.loginAddress
          }
        })
        .catch(err => {
          this.$message.error(err.data.message || '登出失败，请稍后重试')
        })
        .finally(() => (this.loading = false))
    },

    createNewCompany() {
      window.location.href = `${this.loginAddress}/cert/new/select`
    },

    /**
     * 第三方登陆时，根据公司id，直接进入企业
     */
    enterCompanyFromThirdAccess() {
      const pageQuery = JSON.parse(this.$route.query.jumpPath)?.query?.pageQuery
      const pageQueryObj = pageQuery ? JSON.parse(pageQuery) : {}
      // 有登录公司id，则匹配登录公司id
      if (pageQueryObj.loginCompanyId) {
        const company = this.companyList.find(
          el => el.companyId === pageQueryObj.loginCompanyId
        )
        if (company.companyId) {
          this.fullScreenLoading = true
          setTimeout(() => {
            this.enterCompany(company)
          }, 0)
        }
      }
      // 有登录企业名称，则匹配登录企业名称
      if (pageQueryObj.loginCompanyName) {
        const company = this.companyList.find(
          el => el.companyName === pageQueryObj.loginCompanyName
        )
        if (company.companyId) {
          this.fullScreenLoading = true
          setTimeout(() => {
            this.enterCompany(company)
          }, 0)
        }
      }
    },

    /**
     * 进入企业
     */
    enterCompany(company) {
      if (company.companyStatus === companyStatusDict.FORBIDDEN.value) {
        this.$message.warning('当前企业已被禁用，请选择其它企业')
        this.fullScreenLoading = false
        return
      }
      enterCompanyApi({
        employeeId: company.employeeId,
        companyId: company.companyId
      })
        .then(res => {
          // 登录成功后跳转
          const jumpPath = JSON.parse(this.jumpPath)

          if (isObject(jumpPath)) {
            if (jumpPath.name || jumpPath.path) {
              this.$router.replace(jumpPath)
            } else {
              this.$router.replace({ name: 'Homepage' })
            }
          } else {
            this.$router.replace({
              name: 'BlankPage',
              query: this.$route.query
            })
          }
        })
        .catch(err => {
          this.$message.error(err.message || '登录企业失败，请稍后重试')
        })
        .finally(() => {
          this.fullScreenLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
$background-light-blue-color: #dfefff;

.company-list-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  min-height: 540px;
  background: url('~@/assets/images/select-company/background.png') no-repeat
    center center;
  background-size: cover;
}

//.nav-bar {
//  height: pixel-to-rem($n: 100);
//  background: $white-color;
//  padding: 0 2.5rem;
//  box-sizing: border-box;
//  box-shadow: 0 0 5px #ccc;
//
//  // 顶部当行栏左侧样式
//  .nav-bar__left {
//    font-size: 24px;
//    color: $primary-color;
//
//    .platform-title {
//      @include text-bold;
//      white-space: nowrap;
//    }
//  }
//}

.el-divider--horizontal {
  margin: 30px 0 10px 0;
}

.company-select-card {
  width: 50%;
  max-width: 800px;
  height: calc(100% - 190px);
  margin: 40px auto 0;
  .title {
    text-align: center;
    font-size: 24px;
    @include text-bold;
    margin-bottom: pixel-to-rem($n: 10);
  }
}

.card-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  height: 100%;

  .title-tip {
    width: 100%;
    text-align: center;
    font-size: pixel-to-rem($n: 18);
    color: $third-text-color;
  }
}

.no-company-tip {
  width: 100%;
  text-align: left;
  color: $third-text-color;
}

.company-list {
  max-height: calc(100% - 40px);
  overflow: auto;
  width: 100%;
  margin-top: pixel-to-rem($n: 20);
  .company {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 3.75rem;
    padding: 1rem;
    box-sizing: border-box;
    border: 1px solid $border-color;
    border-radius: 4px;
    cursor: pointer;

    .company-info {
      display: flex;
      align-items: center;

      .company-logo {
        margin-right: pixel-to-rem($n: 20);
      }
    }

    &:not(:last-child) {
      margin-bottom: pixel-to-rem($n: 10);
    }

    &.active,
    &:hover {
      color: $primary-color;
      border-color: $primary-color;
    }

    &.disabled {
      color: $third-text-color;
      &:hover {
        cursor: not-allowed;
        color: $third-text-color;
        border-color: $border-color;
      }
    }
  }
  /*定义滚动条高宽及背景
 高宽分别对应横竖滚动条的尺寸*/
  &::-webkit-scrollbar {
    width: 5px;
    height: 10px;
    background-color: #f5f5f5;
  }
  /*定义滚动条轨道
   内阴影+圆角*/
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #f5f5f5;
  }
  /*定义滑块
   内阴影+圆角*/
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #aaa;
    //background-image: -webkit-linear-gradient(45deg,
    //  rgba(255, 255, 255, .2) 25%,
    //  transparent 25%,
    //  transparent 50%,
    //  rgba(255, 255, 255, .2) 50%,
    //  rgba(255, 255, 255, .2) 75%,
    //  transparent 75%,
    //  transparent);
    //background-image: -webkit-gradient(linear,
    //  left bottom,
    //  left top,
    //  color-stop(0.44, rgb(122,153,217)),
    //  color-stop(0.72, rgb(73,125,189)),
    //  color-stop(0.86, rgb(28,58,148)));
  }
}

.footer {
  position: absolute;
  bottom: 40px;
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: $third-text-color;
  .friendly-links {
    ::v-deep .el-link {
      color: inherit;
      margin-right: pixel-to-rem($n: 10);
      font-size: inherit;
      &:not(:last-child) {
        &::after {
          display: inline-block;
          content: '|';
          margin-left: pixel-to-rem($n: 10);
        }
      }

      .el-link--inner {
        &:hover {
          color: $primary-color;
        }
      }
    }
  }
  div {
    margin-bottom: pixel-to-rem($n: 5);
    &:last-child {
      margin-top: pixel-to-rem($n: 10);
    }
  }
  .copy-right {
    span {
      color: $third-text-color;
      font-size: pixel-to-rem($n: 14);
      margin: 0;
    }

    a {
      color: $third-text-color;
      text-decoration: none;
      font-size: pixel-to-rem($n: 14);

      &:hover {
        color: $primary-color;
      }
    }
  }
}

.operate {
  margin-top: pixel-to-rem($n: 10);
  width: 100%;
  text-align: center;

  .add-company {
    display: flex;
    align-items: center;
    padding: pixel-to-rem($n: 16);
    box-sizing: border-box;
    border: 1px solid $border-color;
    border-radius: 4px;
    cursor: pointer;

    .add-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: pixel-to-rem($n: 28);
      height: pixel-to-rem($n: 28);
      background-color: $background-light-blue-color;
      font-size: pixel-to-rem($n: 16);
      color: $primary-color;
      margin-right: 10px;
    }
    .add-button {
      color: $second-text-color;
      font-size: pixel-to-rem($n: 18);
    }

    &:hover {
      border-color: $primary-color;
      .add-button {
        color: $primary-color;
      }
    }
  }

  .back-login-button {
    width: 100%;
    height: pixel-to-rem($n: 56);
    margin-top: pixel-to-rem($n: 30);
  }
}
</style>
